'use strict';

var App = require('app');
var I18N = require('utils/i18n');
var OOP = require('utils/oop');

module.exports = OOP.extend(Marionette.ItemView, {
    template: require('components/common/templates/breadcrumbs'),

    events: OOP.inheritedObj('events', {
        'click a.js-action': function (e) {
            e.preventDefault();

            switch (e.currentTarget.id) {
                case 'js-action-add':
                    this.options.controller.reportDevicesContentAdd(this.options.id);
                    break;
                case 'js-action-edit':
                    this.options.controller.reportDevicesEdit(this.options.id, true);
                    break;
                case 'js-action-refresh':
                    App.trigger('profile:reports:device', this.options.id);
                    break;
                case 'js-action-download-current':
                    window.location = '/api/v1/devices/reports/' + this.options.id + '/preview.pdf?download=1';
                    break;
            }
        },
    }),

    serializeData: function () {
        return {
            base: {
                link: '#profile/report-devices',
                title: I18N.TR('Geräteberichte'),
            },
            device: {
                id: this.options.id,
                attributes: {
                    name: this.options.name,
                },
            },
            target: {
                title: I18N.TR('Inhalt'),
            },
            actions: [
                {
                    idx: '-add',
                    icon: 'fa fa-plus',
                    show_me: this.options.format.name != 'CSV',
                },
                {
                    idx: '-edit',
                    icon: 'fa fa-cog',
                    show_me: true,
                },
                {
                    idx: '-refresh',
                    icon: 'fa fa-refresh',
                    show_me: true,
                },
                {
                    idx: '-download-current',
                    icon: 'fa fa-download',
                    show_me: true,
                },
            ],

            icon: this.options.format,
            noSiblings: true,
        };
    },
});
